module.exports = __webpack_public_path__ + "static/media/maps-combined_2020-04-03.a5e4ded4.png";